import React, { Profiler } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Login from './pages/login';
import Register from './pages/register';
import VerifyOtp from './pages/verify-otp';
import Home from './pages/home';
import AddMoney from './pages/add-money';
import Operator from './pages/operator';
import PaymentConfirmation from './pages/payment-confirmation';
import DthRecharge from './pages/dth-recharge';
import ProfileEdit from './pages/profile-edit';
import SupportCenter from './pages/support-center';
import History from './pages/history';
import Margin from './pages/margin';
import ProfileDetails from './pages/profile';
import RedeemCodeRecharge from './pages/redeem-code-recharge';
import ReferCode from './pages/refer-code';
import Setting from './pages/setting';
import TransactionDetail from './pages/transaction-details';
import MobileRecharge from './pages/mobile-recharge';
import Notification from './pages/notification';
import PaymentStatus from './pages/payment-status';
import MobileRechargePlan from './pages/mobile-recharge-plan';
import OperatorForm from './pages/operator-form';
import UPIIntent from './pages/payment/upi-intent';
import About from './pages/about';
import KycVerification from './pages/kyc-verification';
import PreLoading from './pages/pre-loading';
import { apiCall } from './utils/api';

window.addEventListener("message", async (event) => {
  try {
    // Check if event.data is a string or object
    let data;
    if (typeof event.data === 'string') {
      data = JSON.parse(event.data);
    } else {
      // If it's already an object, use it directly
      data = event.data;
    }

    if (data.type === "DEVICE_INFO") {
      const storedUserData = localStorage.getItem("credentials");
      const parsedData = storedUserData ? JSON.parse(storedUserData) : null;

      const payload = {
        user_id: parsedData?.user_id || null,
        token: parsedData?.login_token || null,
        device_token: data?.token || null,
        device_id: data?.device_id || null,
        platform: data?.platform || null
      };

      try {
        const result = await apiCall("save-notification-token", payload, false);
        if (result.status === true) {
          console.log("Notification token saved successfully!");
        } else {
          console.error("Failed to save notification token:", result.message);
        }
      } catch (error) {
        console.error("Network error:", error);
      }
    }
  } catch (e) {
    console.error("Error in message listener:", e);
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="*" element={<PreLoading />} />
      <Route path="/" element={<PreLoading />} />
      <Route path="/home" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify-otp" element={<VerifyOtp />} />
      <Route path="/add-money" element={<AddMoney />} />
      <Route path="/operator" element={<Operator />} />
      <Route path="/operator-form" element={<OperatorForm />} />
      <Route path="/payment-confirmation" element={<PaymentConfirmation />} />
      <Route path="/dth-recharge" element={<DthRecharge />} />
      <Route path="/profile-edit" element={<ProfileEdit />} />
      <Route path="/support-center" element={<SupportCenter />} />
      <Route path="/history" element={<History />} />
      <Route path="/margin" element={<Margin />} />
      <Route path="/profile" element={<ProfileDetails />} />
      <Route path="/redeem-code-recharge" element={<RedeemCodeRecharge />} />
      <Route path="/refer-code" element={<ReferCode />} />
      <Route path="/setting" element={<Setting />} />
      <Route path="/transaction-detail" element={<TransactionDetail />} />
      <Route path="/mobile-recharge" element={<MobileRecharge />} />
      <Route path="/notification" element={<Notification />} />
      <Route path="/payment-status" element={<PaymentStatus />} />
      <Route path="/about" element={<About />} />
      <Route path="/mobile-recharge-plan" element={<MobileRechargePlan />} />
      <Route path="/payment/upi-intent" element={<UPIIntent />} />
      <Route path="/kyc-verification" element={<KycVerification />} />
    </Routes>
  </BrowserRouter>
);
reportWebVitals();
